import { createRouter, createWebHistory } from "vue-router";
import DefaultLayout from "@/views/DefaultLayout.vue";
import LandingLayout from "@/views/LandingLayout.vue";
import LandingPage from "../views/LandingPage.vue";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    component: LandingLayout,
    children: [
      {
        path: "",
        name: "landing",
        component: LandingPage,
      },
    ],
  },
  {
    path: "/home",
    component: DefaultLayout,
    children: [
      {
        path: "/home",
        name: "home",
        component: HomeView,
      },
      {
        path: "/works",
        name: "works",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/HomeView.vue"),
      },
      {
        path: "/about",
        name: "about",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
      },
      {
        path: "/web",
        name: "web",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "web" */ "../views/WebView.vue"),
      },
      {
        path: "/design",
        name: "design",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "design" */ "../views/DesignView.vue"),
      },
      {
        path: "/audio",
        name: "audio",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "audio" */ "../views/AudioView.vue"),
      },
      {
        path: "/sound",
        name: "sound",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "sound" */ "../views/SoundView.vue"),
      },
      {
        path: "/t-a-e",
        name: "transamericaexpress",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "tae" */ "../views/TaeView.vue"),
      },
      {
        path: "/contact",
        name: "contact",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "contact" */ "../views/ContactView.vue"),
      },
      {
        path: "/links",
        name: "links",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "links" */ "../views/LinksView.vue"),
      },
      {
        path: "/privacy",
        name: "privacy",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "privacy" */ "../views/PrivacyView.vue"),
      },
      {
        path: "/imprint",
        name: "imprint",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "imprint" */ "../views/ImprintView.vue"),
      },
      {
        path: "/tae-vip",
        name: "tae-vip",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(
            /* webpackChunkName: "imprint" */ "../views/TaeprotectedView.vue"
          ),
      },
      {
        path: "/tae-vip2",
        name: "tae-vip2",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "imprint" */ "../views/TaeVip.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return { el: to.hash, behavior: "smooth", top: 80 };
    }
    return { top: 0 };
  },
});

export default router;
